import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

export const AdjustmentService = {
  getAllAdj: async () => {
    try {
      const response = await axios.get(ENDPOINT.Adjustment);
      return response.data;
    } catch (error) {
      console.error("Error fetching Adjustments:", error.message);
      throw error;
    }
  },

  getAdjStats: async () => {
    try {
      const response = await axios.get(`${ENDPOINT.Adjustment}/stats`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Adjustment stats:", error.message);
      throw error;
    }
  },

  getLastAdj: async () => {
    try {
      const response = await axios.get(`${ENDPOINT.Adjustment}/last`);
      return response.data;
    } catch (error) {
      console.error("Error fetching last Adjustment:", error.message);
      throw error;
    }
  },

  getDistinctValues: async (field) => {
    try {
      const response = await axios.get(`${ENDPOINT.Adjustment}/distinct/${field}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching distinct values:", error.message);
      throw error;
    }
  },

  getAdjById: async (id) => {
    try {
      const response = await axios.get(`${ENDPOINT.Adjustment}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Adjustment:", error.message);
      throw error;
    }
  },

  createAdj: async (data) => {
    try {
      const response = await axios.post(ENDPOINT.Adjustment, data, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating Adjustment:", error.message);
      throw error;
    }
  },

  updateAdj: async (data, id) => {
    try {
      const response = await axios.put(`${ENDPOINT.Adjustment}/${id}`, data, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      console.error("Error updating Adjustment:", error.message);
      throw error;
    }
  },

  updateStatus: async (id, status) => {
    try {
      const response = await axios.put(`${ENDPOINT.Adjustment}/${id}/status`, { status });
      return response.data;
    } catch (error) {
      console.error("Error updating Adjustment status:", error.message);
      throw error;
    }
  },

  deleteAdj: async (id) => {
    try {
      const response = await axios.delete(`${ENDPOINT.Adjustment}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting Adjustment:", error.message);
      throw error;
    }
  },
};